"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.proposedStageOne = void 0;
var Joi = require('joi').extend(require('@joi/date'));
exports.proposedStageOne = Joi.object({
    conversionOfRepaymentArrangementToAFixedRateEqualPaymentMortgage: Joi.boolean()
        .allow('')
        .optional(),
    effectiveDate: Joi.date()
        .max('12-31-9999')
        .when('conversionOfRepaymentArrangementToAFixedRateEqualPaymentMortgage', {
        is: true,
        then: Joi.date().required(),
        otherwise: Joi.date()
            .strip()
            .allow('')
            .optional(),
    }),
    mortgagePaymentDeferral: Joi.boolean()
        .allow('')
        .optional(),
    newRate: Joi.number()
        .min(0)
        .max(99999.9999)
        .precision(4)
        .options({ convert: false })
        .when('conversionOfRepaymentArrangementToAFixedRateEqualPaymentMortgage', {
        is: true,
        then: Joi.number().required(),
        otherwise: Joi.number()
            .strip()
            .allow('')
            .optional(),
    }),
    prepayAndReBorrow: Joi.boolean()
        .allow('')
        .optional(),
    totalDeferredAmount: Joi.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .when('mortgagePaymentDeferral', {
        is: true,
        then: Joi.number().required(),
        otherwise: Joi.number()
            .strip()
            .allow('')
            .optional(),
    }),
    totalMonthsDeferred: Joi.number()
        .min(0)
        .max(999.99)
        .precision(2)
        .options({ convert: false })
        .when('mortgagePaymentDeferral', {
        is: true,
        then: Joi.number().required(),
        otherwise: Joi.number()
            .strip()
            .allow('')
            .optional(),
    }),
    totalPrepay: Joi.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .when('prepayAndReBorrow', {
        is: true,
        then: Joi.number().required(),
        otherwise: Joi.number()
            .strip()
            .allow('')
            .optional(),
    }),
    totalReBorrowed: Joi.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .when('prepayAndReBorrow', {
        is: true,
        then: Joi.number().required(),
        otherwise: Joi.number()
            .strip()
            .allow('')
            .optional(),
    }),
});
exports.default = { proposedStageOne: exports.proposedStageOne };
